<template>
  <div id="marquee-main-container" :class="{'cti-is-login': isLoggedIn, 'cti-not-login': !isLoggedIn}">
    <div class="marquee-item" :key="idx" v-for="(slogan, idx) in slogans" v-text="slogan" />
  </div>
</template>

<script>

import Slogan from '@/models/Slogan'
export default {
  data () {
    return {
      slogans: [],
      slider: {
        step: 1,
        speed: 50,
        retry: 1000
      }
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
  },
  mounted () {
    this.loadSlogans()
  },
  methods: {
    async loadSlogans () {
      const response = await Slogan.getAllActive()
      this.slogans = response.data
      const self = this
      if (this.slogans.length > 0) {
        setTimeout(function () {
          self.prepareSlide(0)
        }, 1000)
      }
    },
    slide (index) {
      const mainContainer = document.getElementById('marquee-main-container')
      const mainContainerWidth = mainContainer.offsetWidth
      const items = document.querySelectorAll('.marquee-item')
      const activeSlide = items[index]
      const activeSlideStyle = window.getComputedStyle(activeSlide)
      const activeSlideMarginLeft = activeSlideStyle.marginLeft
      const activeSlideMarginLeftValue = parseInt(activeSlideMarginLeft, 10)
      const activeSlideWidth = activeSlide.offsetWidth
      const activeSlideWidthIncludingMarginLeft = activeSlideMarginLeftValue + activeSlideWidth
      const self = this

      if (mainContainerWidth > 0) {
        if (activeSlideWidthIncludingMarginLeft > 0) {
          const activeSlideMarginLeftNewValue = activeSlideMarginLeftValue - this.slider.step
          document.querySelectorAll('.marquee-item')[index].style.marginLeft = `${activeSlideMarginLeftNewValue}px`
          setTimeout(function () {
            self.slide(index)
          }, self.slider.speed)
        } else {
          let indexItem = index + 1
          if (indexItem === items.length) {
            indexItem = 0
          }
          this.prepareSlide(indexItem)
        }
      } else {
        setTimeout(function () {
          self.slide(index)
        }, self.slider.retry)
      }
    },
    prepareSlide (index) {
      // reset all position
      const items = document.querySelectorAll('.marquee-item')
      items.forEach(item => {
        item.style.marginLeft = `${document.getElementById('marquee-main-container').offsetWidth}px`
        item.classList.remove('active')
      })
      items[index].classList.add('active')
      this.slide(index)
    }
  }
}

</script>

<style type="text/css">
#marquee-main-container {
  overflow: hidden;
  position: relative;
  width: 250px;
  height: 39px;
  border: solid 1px #ccc;
}
.marquee-item {
  position: absolute;
  white-space: nowrap;
  padding: 8px;
  display: none;
}
.marquee-item.active {
  display: block;
}
@media (max-width: 1060px) {
  .cti-not-login#marquee-main-container {
    display: none !important;
  }
}
@media (max-width: 1720px) {
  .cti-is-login#marquee-main-container {
    display: none !important;
  }
}
</style>
